import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const TipaltiIdSchema = z.string().brand('tipalti-id')

export type TipaltiId = ZodInfer<typeof TipaltiIdSchema>

export const TipaltiId = (value: string): TipaltiId => {
  return TipaltiIdSchema.parse(value)
}
